import { ScreenType } from "../../types";

export default class GemMeterBaseRule {
  static ruleId: string;

  static getIframeDocument() {
    const iframe = document.getElementById('gfFrame') as HTMLIFrameElement;
    if (!iframe) {
      return null;
    }

    return iframe.contentDocument;
  }

  static getElement(selector: string) {
    const ifDocument = GemMeterBaseRule.getIframeDocument();
    if (!ifDocument) {
      return null;
    }

    return ifDocument.querySelector(selector);
  }

  static getElements(selector: string) {
    const ifDocument = GemMeterBaseRule.getIframeDocument();
    if (!ifDocument) {
      return null;
    }

    return ifDocument.querySelectorAll(selector);
  }

  static validate: (selector: string, screenSize: ScreenType) => boolean;
}
